/**
 * 行動分析タブの表示用フォーマッタ。
 */

export const formatMs = (ms: number | null | undefined): string => {
  if (ms === null || ms === undefined || Number.isNaN(ms)) return '-';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)}秒`;
  const minutes = Math.floor(seconds / 60);
  const rest = Math.round(seconds % 60);
  if (minutes < 60) return `${minutes}分${String(rest).padStart(2, '0')}秒`;
  const hours = Math.floor(minutes / 60);
  return `${hours}時間${String(minutes % 60).padStart(2, '0')}分`;
};

export const formatPercent = (value: number | null | undefined): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return '-';
  return `${value.toFixed(1)}%`;
};

export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return '-';
  return value.toLocaleString('ja-JP');
};

export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '-';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString('ja-JP', { hour12: false });
};

export const formatTime = (iso: string | null | undefined): string => {
  if (!iso) return '-';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleTimeString('ja-JP', { hour12: false });
};

const pad = (n: number): string => String(n).padStart(2, '0');

export const toDateString = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/** 今日を終点に days 日分の from / to（YYYY-MM-DD）を返す */
export const rangeForDays = (days: number): { from: string; to: string } => {
  const to = new Date();
  const from = new Date();
  from.setDate(to.getDate() - (days - 1));
  return { from: toDateString(from), to: toDateString(to) };
};

export const EVENT_TYPE_LABELS: Record<string, string> = {
  page_view: '画面表示',
  page_leave: '画面離脱',
  click: 'クリック',
  step: 'ステップ',
  action: '操作',
  api_error: 'APIエラー',
  api_timing: '遅いAPI',
  js_error: 'JSエラー',
};

export const DEVICE_LABELS: Record<string, string> = {
  desktop: 'PC',
  mobile: 'スマホ',
  tablet: 'タブレット',
};
